import React from 'react';
import { ajaxGet, ajaxPost, AjaxResponseType } from '../../common/form/FrekulForm';

export const defaultKaraokeOrderClient = {
  getMusic(musicId: number): Promise<AjaxResponseType & {
    title: string,
    title_kana: string,
    artist_name: string,
    artist_name_kana: string,
    composer_name: string,
    lyric_writer_name: string,
  }> {
    return ajaxGet(`/karaoke_orders/ajax_get_music/${musicId}`);
  },
  validateFirstKaraokeOrder(formData: {
    royalty_order: string,
    onvocal: string,
    physical: string,
    duet: string,
    coupon_code: string,
    already_entrusted: string,
  }): Promise<AjaxResponseType & {
    discountAmount: number,
    paymentAmount: number,
    billingAmount: number,
    hasNonAppliedInitialOrderCoupon: boolean,
  }> {
    const postData: {
      royalty_order: string,
      onvocal: string,
      physical: string,
      duet: string,
      coupon_code: string,
      already_entrusted?: string,
    } = { ...formData };
    if (postData.royalty_order === 'with_royalty') {
      delete postData.already_entrusted;
    }
    return ajaxPost('/karaoke_orders/ajax_validate_first', postData, {}, true);
  },
  validateKaraokeOrder(formData: {
    title: string,
    title_kana: string,
    artist_name: string,
    artist_name_kana: string,
    lyric_writer_name: string,
    composer_name: string,
    applicant_name: string,
    vocal_synthesizer_name: string,
    payment_method: string,
  }, cardToken: string|null): Promise<AjaxResponseType & {
    discountAmount: number,
    paymentAmount: number,
    billingAmount: number,
    hasNonAppliedInitialOrderCoupon: boolean,
  }> {
    const postData: {
      title: string,
      title_kana: string,
      artist_name: string,
      artist_name_kana: string,
      lyric_writer_name: string,
      composer_name: string,
      applicant_name: string,
      vocal_synthesizer_name: string,
      payment_method: string,
      cc_card_token?: string,
    } = { ...formData };
    if (postData.payment_method === 'cc_payment' && cardToken !== null) {
      postData.cc_card_token = cardToken;
    }

    return ajaxPost('/karaoke_orders/ajax_validate', postData, {}, true);
  },
  executeKaraokeOrder(formData: {
    title: string,
    title_kana: string,
    artist_name: string,
    artist_name_kana: string,
    lyric_writer_name: string,
    composer_name: string,
    applicant_name: string,
    vocal_synthesizer_name: string,
    payment_method: string,
  }, cardToken: string|null): Promise<AjaxResponseType & {
    redirectUrl: string,
  }> {
    const postData: {
      title: string,
      title_kana: string,
      artist_name: string,
      artist_name_kana: string,
      lyric_writer_name: string,
      composer_name: string,
      applicant_name: string,
      vocal_synthesizer_name: string,
      payment_method: string,
      cc_card_token?: string,
    } = { ...formData };
    if (postData.payment_method === 'cc_payment' && cardToken !== null) {
      postData.cc_card_token = cardToken;
    }
    return ajaxPost('/karaoke_orders/ajax_execute', postData, {}, true);
  },
  loginOrRegister(formData: {
    artist_registration_type: string,
    artist_registration_mbmail: string,
    artist_registration_password: string,
  }): Promise<AjaxResponseType> {
    const postData = {
      artist_registration_type: formData.artist_registration_type,
      artist_registration_mbmail: formData.artist_registration_mbmail,
      artist_registration_password: formData.artist_registration_password,
      artist_registration_agreement: '1',
    };
    return ajaxPost('/karaoke_orders/ajax_login_or_register', postData, {}, true);
  },
};

export const KaraokeOrderClientContext = React.createContext(defaultKaraokeOrderClient);
